import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { apiLoadingStatusSaga } from '../../redux/saga/merchantServiceSelectors';

export function CircularProgressLoader() {
  const statusText = useSelector(apiLoadingStatusSaga);

//   useEffect(()=>{
//     console.log('Loader status ',statusText)
//   },[statusText])
  return (
    <>
      {
        <div className='loader-style'>
          <div className='loader-content'>
            <CircularProgress />
            <p>{statusText}</p>
          </div>
        </div>
      }
    </>
  );
}
